<form [formGroup]="formGroup">
    <input type="text"
           minlength="7"
           [formControl]="ctrlFullTag"
           [attr.placeholder]="placeholder"
           [attr.disabled]="disabled ? disabled : null"
           [aaAutocomplete]="tagac"
           class="ac-input" />
    <aa-autocomplete #tagac="autoComplete">
        <ng-template aaAutocompleteContent>
            <ng-container *ngIf="((availableTags | async) |  autocompleteFilter : ctrlFullTag.value : 'fullTagName') as result">
                <aa-autocomplete-option *ngFor="let tag of result"
                                        [value]="tag">
                    <div class="chips-tag-item pointer"
                         (click)="onClick(tag.tagId)"
                         [style.color]="tag.fgColor"
                         [style.backgroundColor]="tag.bgColor">
                        {{ tag.fullTagName }}
                    </div>
                </aa-autocomplete-option>
                <aa-autocomplete-option *ngIf="result.length">
                    <div class="chips-tag-item infos">
                        Click to select
                    </div>
                </aa-autocomplete-option>
                <aa-autocomplete-option *ngIf="!result.length">
                    <div class="chips-tag-item infos">
                        No more tag...
                    </div>
                </aa-autocomplete-option>
            </ng-container>
        </ng-template>
    </aa-autocomplete>
    <i class="far fa-plus chips-actions chips-tag-add"
       title="{{'CMDB.TAGS.CREATE.TITLE' | translate}}"
       (click)="onCreate()">
    </i>
</form>
